import React from 'react';
import { Button } from '../ui/Button';
import { useDrawers } from '../../contexts/DrawerContext';
import { Phone, FileText } from 'lucide-react';
export function FinalCTA() {
  const {
    openQuote,
    openUpload
  } = useDrawers();
  return <section className="px-5 md:px-6 py-16 md:py-24 bg-background" data-id="element-253">
      <div className="max-w-7xl mx-auto" data-id="element-254">
        <div className="relative overflow-hidden rounded-4xl bg-ink text-cream px-7 py-14 md:px-16 md:py-20" data-id="element-255">
          {/* warm imagery wash */}
          <img src="https://images.unsplash.com/photo-1600566753086-00f18fb6b3ea?auto=format&fit=crop&w=1400&q=80" alt="" aria-hidden="true" className="absolute inset-0 w-full h-full object-cover opacity-20" data-id="element-256" />
          <div className="absolute inset-0" style={{
          background: 'linear-gradient(120deg, rgba(42,37,33,0.92) 35%, rgba(42,37,33,0.55) 100%)'
        }} aria-hidden="true" data-id="element-257" />

          <div className="relative max-w-2xl" data-id="element-258">
            <p className="text-accent-light font-script text-2xl mb-2" data-id="element-259">
              before you sign
            </p>
            <h2 className="font-serif text-3xl md:text-5xl leading-[1.1] text-cream" data-id="element-260">
              Get clear on what the contract actually means.
            </h2>
            <p className="mt-5 text-lg text-cream/75 leading-relaxed" data-id="element-261">
              Tell us about any auction, offer or signing deadline and the team
              will assess how quickly your matter needs to move.
            </p>

            <div className="mt-8 flex flex-col sm:flex-row gap-3" data-id="element-262">
              <Button onClick={openUpload} variant="accent" size="lg" className="w-full sm:w-auto" data-id="element-263">
                <FileText className="w-5 h-5" data-id="element-264" />
                Upload your contract
              </Button>
              <Button onClick={openQuote} size="lg" className="w-full sm:w-auto bg-cream text-ink hover:bg-white" data-id="element-265">
                Request a quote
              </Button>
            </div>

            <a href="tel:+61386172600" className="mt-6 inline-flex items-center gap-2 text-cream/85 hover:text-white font-semibold transition-colors" data-id="element-266">
              <Phone className="w-4 h-4" data-id="element-267" />
              Call (03) 8617 2600
            </a>
          </div>
        </div>
      </div>
    </section>;
}